export default __webpack_public_path__ + "static/media/pie_contrato.fc0e1202.png";